import { keyBy, uniqBy, words } from "lodash";
import { ItemModType } from "./CustomerTab/schema";
import { Item, ItemMod, Menu, Section } from "./schema";

type ItemModWithItemModGroup = ItemMod & {
  itemModType: ItemModType;
  itemModGroupUuid: string;
};

export const getItemModsList = (
  item: Item
): { [index: string]: ItemModWithItemModGroup } => {
  const modsList: ItemModWithItemModGroup[] = item.itemModGroups.flatMap(
    (modGroup) =>
      modGroup.itemMods.map((itemMod: ItemMod) => ({
        ...itemMod,
        itemModType: modGroup.modGroupType,
        itemModGroupUuid: modGroup.uuid,
      }))
  );
  const mods = keyBy(modsList, "uuid");
  return mods;
};

export const getActiveSections = (menu: Menu): Section[] => {
  const isActiveSection = (section: Section): boolean =>
    section.items.length > 0;
  return menu.sections.filter(isActiveSection);
};

export const getPromotions = (menu: Menu): Item[] => {
  return uniqBy(
    menu.sections
      .flatMap((s) => s.items)
      .filter((i) => menu.promotions.map((p) => p.itemUuid).includes(i.uuid))
      .filter((i) => i.heroImageUrl),
    "uuid"
  );
};

export const getItemsForSearchTerm = (
  menu: Menu,
  searchTerm: string
): (Item & { sectionUuid: string })[] => {
  const sections = getActiveSections(menu);
  const items = sections.flatMap((section) =>
    section.items.map((item) => ({ ...item, sectionUuid: section.uuid }))
  );
  const uniqItems = uniqBy(items, "uuid");
  const searchWords = words(searchTerm.toLowerCase());
  const matchingItems = uniqItems.filter((item) =>
    searchWords.every((word) => item.name.toLowerCase().includes(word))
  );
  return matchingItems;
};
